import { select } from 'redux-saga/effects';

export const selectCurrentInitiativeId = () => select((state) => state.core.initiatives.byId.get.data?.id);
